// extracted by mini-css-extract-plugin
export default {"header":"style_header__RxAj7","main-image":"style_main-image__JYqqS"};